import dayjs from 'dayjs';
import { saveAs } from 'file-saver';

export const downloadJson = (data: any, filename: string) => {
    const jsonStr = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}_${dayjs(new Date()).format('YYYY-MM-DD_hh-mm-ss')}.json`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const downloadXlsx = (data: any, filename: string) => {
    const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${filename}_${dayjs(new Date()).format('YYYY-MM-DD_hh-mm-ss')}.xlsx`);
};
